import { inject, Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { GetOrganizerBalanceResponse, OrganizersService } from '@smatchy/sdk';
import { GetBalances, GetBalancesSuccess } from './balances.actions';
import { catchError, of, tap } from 'rxjs';
import { FailAction } from '../payouts';
export interface BalancesStateModel {
  isLoading: boolean;
  error?: unknown;
  balance?: GetOrganizerBalanceResponse;
}
@State<BalancesStateModel>({
  name: 'balances',
})
@Injectable()
export class BalancesState {
  private readonly _organizersService = inject(OrganizersService);
  @Action(GetBalances)
  getBalances({ patchState, dispatch }: StateContext<BalancesStateModel>) {
    patchState({ isLoading: true, error: null });
    return this._organizersService.getBalance().pipe(
      tap((response) => {
        dispatch(new GetBalancesSuccess(response as GetOrganizerBalanceResponse));
      }),
      catchError((error) => {
        console.error('Failed to load balances:', error);
        dispatch(new FailAction(error));
        return of(error);
      }),
    );
  }
  @Action(GetBalancesSuccess)
  getBalancesSuccess(ctx: StateContext<BalancesStateModel>, { payload }: GetBalancesSuccess) {
    return ctx.patchState({
      balance: payload,
      isLoading: false,
      error: null,
    });
  }
  @Action(FailAction)
  loadFail(ctx: StateContext<BalancesStateModel>, action: FailAction) {
    return ctx.patchState({
      isLoading: false,
      error: action.error,
    });
  }
}
